"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'accountPin';
exports.VALIDATE_ACCOUNT_PIN = exports.namespace + "/VALIDATE_ACCOUNT_PIN";
exports.CLEAR_VALIDATE_ACCOUNT_PIN = exports.namespace + "/CLEAR_VALIDATE_ACCOUNT_PIN";
exports.RESET_ACCOUNT_PIN = exports.namespace + "/RESET_ACCOUNT_PIN";
//# sourceMappingURL=constants.js.map